import angular from 'angular';

class modalExportReminderCtrl {
  /* @ngInject */
  constructor(logger) {
    this.logger = logger;
  }

  exportReminder(type) {
    this.modalInstance.close(type);
  }

  cancel() {
    this.modalInstance.dismiss();
  }
}

angular.module('app.principal').component('modalExportReminder', {
  templateUrl: require('./modal-export-reminder.html'),
  controller: modalExportReminderCtrl,
  bindings: {
    modalInstance: '<',
    resolve: '<'
  }
});
